import { countryRoutes, apiRoutes } from 'commons/js/routes'
import UrlTo from './UrlTo'

UrlTo.setRoutes(countryRoutes, apiRoutes)

export function toUrlSearchParams (params) {
    return Object.keys(params).reduce((urlSearchParams, name) => {
        urlSearchParams.set(name, params[name])
        return urlSearchParams
    }, new URLSearchParams())
}

export default UrlTo
